export default __webpack_public_path__ + "static/media/Gallery - Edition II vs IV - 1_00.316ce41f.jpg";